const STORAGE_KEY = 'weeTime_privacy';
const GA_ID = 'G-V8280M0CEB';

export const defaultConsent = {
  essential: true,
  analytics: false,
};

export function getConsent() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      if (parsed && typeof parsed.choices === 'object') return parsed;
    }
  } catch (e) { /* ignore corrupted data */ }
  return null;
}

export function hasConsented() {
  return getConsent() !== null;
}

function generateId() {
  return crypto.randomUUID ? crypto.randomUUID() : Date.now().toString(36) + Math.random().toString(36).slice(2);
}

function buildRecord(choices, action) {
  return {
    consentId: generateId(),
    timestamp: new Date().toISOString(),
    choices: { essential: true, analytics: !!choices.analytics },
    bannerVersion: '1.1',
    privacyPolicyVersion: '2.3',
    action,
  };
}

function saveRecord(record) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(record));
}

function injectGtag() {
  if (document.querySelector('script[src*="googletagmanager.com/gtag"]')) return;
  const s = document.createElement('script');
  s.async = true;
  s.src = 'https://www.googletagmanager.com/gtag/js?id=' + GA_ID;
  document.head.appendChild(s);
  s.onload = function () {
    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', GA_ID);
  };
}

function removeGaCookies() {
  const hostname = window.location.hostname;
  const parts = hostname.split('.');
  const domains = [hostname, '.' + hostname];
  // Add parent domains: .example.com, .com
  for (let i = 1; i < parts.length; i++) {
    domains.push('.' + parts.slice(i).join('.'));
  }
  const cookies = document.cookie.split(';');
  cookies.forEach(c => {
    const name = c.split('=')[0].trim();
    if (name === '_ga' || name.startsWith('_ga_')) {
      domains.forEach(domain => {
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=' + domain;
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=' + domain + ';SameSite=Lax';
      });
      // Also try without domain (current domain only)
      document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/';
    }
  });
}

function applyConsent(choices) {
  if (choices.analytics) {
    injectGtag();
  } else {
    removeGaCookies();
  }
}

export function acceptAll() {
  const record = buildRecord({ analytics: true }, 'accept_all');
  saveRecord(record);
  applyConsent(record.choices);
  return record;
}

export function rejectAll() {
  const record = buildRecord({ analytics: false }, 'reject_all');
  saveRecord(record);
  applyConsent(record.choices);
  return record;
}

export function savePreferences(choices) {
  const record = buildRecord(choices, 'save_preferences');
  saveRecord(record);
  applyConsent(record.choices);
  return record;
}

export function withdrawConsent() {
  const record = buildRecord({ analytics: false }, 'withdraw');
  saveRecord(record);
  removeGaCookies();
}

export function initConsent() {
  const record = getConsent();
  if (record && record.choices) {
    applyConsent(record.choices);
  }
}
